import { ScrollTrigger } from '../gsap/setup';

export function initFeatured() {
  const $block = $('.featured-wrapper');
  if (!$block.length) return;

  ScrollTrigger.create({
    trigger: $block[0],
    start: 'top center',
    end: 'bottom center',
    onToggle: ({ isActive }) => {
      if (isActive) {
        document.body.classList.add('is-dark');
      } else {
        document.body.classList.remove('is-dark');
      }
    },
  });
}
